import { CLEAR_ALL, LOGOUT } from '../../../store/Types';

export const ALL_ENT_NIVELES_ACADEMICOS = 'ALL_ENT_NIVELES_ACADEMICOS';
export const ACTIVO_ENT_NIVELES_ACADEMICOS = 'ACTIVO_ENT_NIVELES_ACADEMICOS';
export const LOADING_ALL_ENT_NIVELES_ACADEMICOS =
  'LOADING_ALL_ENT_NIVELES_ACADEMICOS';
export const PARAMS_ENT_NIVELES_ACADEMICOS = 'PARAMS_ENT_NIVELES_ACADEMICOS';

const initialState = {
  all: [],
  activo: null,
  loadingAll: false,
  params: {},
};

export const entNivelesAcademicosReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_ENT_NIVELES_ACADEMICOS:
      return {
        ...state,
        all: action.payload.data.sort(
          (a, b) =>
            Number(a.nivelAcademico.numero) - Number(b.nivelAcademico.numero),
        ),
        links: action.payload.links,
        meta: action.payload.meta,
      };
    case ACTIVO_ENT_NIVELES_ACADEMICOS:
      return {
        ...state,
        activo: action.payload,
      };
    case LOADING_ALL_ENT_NIVELES_ACADEMICOS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case PARAMS_ENT_NIVELES_ACADEMICOS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
